import React from 'react';

export interface ScheduleItem {
    time: string;
    title: string;
    type: 'meeting' | 'call' | 'onboarding' | 'internal';
    duration: string;
}

interface ScheduleWidgetProps {
    schedule: ScheduleItem[];
    onViewCalendar?: () => void;
}

export const ScheduleWidget: React.FC<ScheduleWidgetProps> = ({
    schedule,
    onViewCalendar
}) => {
    return (
        <div className="bg-white portal-content-shadow rounded-lg shadow-sm border border-gray-200 p-6 h-full">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-gray-900">Today's Schedule</h2>
                <button
                    onClick={onViewCalendar}
                    className="text-sm font-medium text-blue-600 hover:text-blue-700"
                >
                    View calendar →
                </button>
            </div>
            <div className="space-y-3">
                {schedule.length > 0 ? (
                    schedule.map((item, index) => (
                        <div
                            key={index}
                            className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
                        >
                            <div className="text-sm font-medium text-gray-500 w-20">
                                {item.time}
                            </div>
                            <div className="flex-1">
                                <p className="text-sm font-medium text-gray-900">{item.title}</p>
                                <p className="text-xs text-gray-500 mt-1">
                                    {item.type === 'meeting' && '📅'}
                                    {item.type === 'call' && '📞'}
                                    {item.type === 'onboarding' && '👋'}
                                    {item.type === 'internal' && '👥'}
                                    {' '}{item.duration}
                                </p>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center py-8 text-gray-500 text-sm">
                        No events scheduled for today
                    </div>
                )}
            </div>
        </div>
    );
};
